module.exports = __webpack_public_path__ + "dcdbe19fdac6fd99f92ddb9934a86b0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/navbar/cashier_redisign-active.png
// module id = 471
// module chunks = 0